<glxy-form-field>
  <glxy-label>{{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.SUBSCRIBERS' | translate }}</glxy-label>
  <forms-input-tags
    [options]="salespeople$ | async"
    [placeholder]="'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.ADD_SUBSCRIBER_PLACEHOLDER' | translate"
    [formControl]="subscribersFormControl"
    [allowCustomTags]="false"
    [allowDuplicates]="false"
    [required]="false"
  />
</glxy-form-field>
